module.exports = __webpack_public_path__ + "static/media/green-pdf.210a70d0.svg";